import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { togglesAtomResettable } from "../diagramming";
import { AssetType } from "../types";

const FOCUS_MODE_SUPPORTED_ASSET_TYPES: string[] = ["zap"];

export const isFocusModeEnabledAtomFamily = atomFamily(
  (assetType: AssetType | null) => {
    const isFocusModeEnabledAtom = atom((get) => {
      const toggles = get(togglesAtomResettable);

      const doesAssetSupportFocusMode =
        !!assetType && FOCUS_MODE_SUPPORTED_ASSET_TYPES.includes(assetType);

      return toggles.isFocusModeEnabledForZap && doesAssetSupportFocusMode;
    });

    isFocusModeEnabledAtom.debugLabel = `isFocusModeEnabledAtomFamily(${assetType})`;
    return isFocusModeEnabledAtom;
  },
);
